// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */
export default {
  list(id) {
    // return firebaseAxios().then((axios) =>
    //   axios
    //     .get(`/users/${id}/history`)
    //     .then((response) => response.data)
    // );
  }
};



// WEBPACK FOOTER //
// ./src/user/user-history/user-history-single/user-history-single-service.js